// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.repository.physical.physical_repository.PhysicalRepository

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { SandboxData, SandboxStore } from "./Sandbox.generated";
import { PhysicalRepositoryWorkspaceData, PhysicalRepositoryWorkspaceStore } from "./PhysicalRepositoryWorkspace.generated";

export interface PhysicalRepositoryData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "PhysicalRepository";
    sandbox: SandboxData | null;
    path: string;
    workspace: PhysicalRepositoryWorkspaceData | null;
    branches: string[];
    active_key: string | null;
}

export class PhysicalRepositoryStore {
    readonly _entity_class_name = "PhysicalRepository" as const;
    sandbox: SandboxStore | null;
    path: string;
    workspace: PhysicalRepositoryWorkspaceStore | null;
    branches: string[];
    active_key: string | null;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: PhysicalRepositoryData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.sandbox = wrapEntity(data.sandbox, transport, [...chainPath, "sandbox"]) ?? null;
        this.path = wrapEntity(data.path, transport, [...chainPath, "path"]);
        this.workspace = wrapEntity(data.workspace, transport, [...chainPath, "workspace"]) ?? null;
        this.branches = wrapEntity(data.branches, transport, [...chainPath, "branches"]);
        this.active_key = wrapEntity(data.active_key, transport, [...chainPath, "active_key"]) ?? null;
        makeObservable(this, {
            sandbox: observable,
            path: observable,
            workspace: observable,
            branches: observable,
            active_key: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async use_key(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "use_key", [name], {});
    }

    async select_branch(branch: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "select_branch", [branch], {});
    }

    async create_branch(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "create_branch", [name], {});
    }
}

registerEntity("PhysicalRepository", PhysicalRepositoryStore);
